import { View, Text, StyleSheet, Animated } from "react-native";
import React from "react";
import { useRef } from "react";

export default function Loading(props) {
  const mode = props.dark !== undefined ? "dark" : "light";
  const darkSet = { start: "#75D7CE", middle: "#457d78", end: "#111111" };
  const lightSet = { start: "#ffffff", middle: "#ebebeb", end: "#bbbbbb" };
  const start = mode === "dark" ? darkSet.start : lightSet.start;
  const middle = mode === "light" ? lightSet.middle : darkSet.middle;
  const end = mode === "light" ? lightSet.end : darkSet.end;
  const animation = useRef(new Animated.Value(0)).current;
  Animated.loop(
    Animated.timing(animation, {
      toValue: 100,
      useNativeDriver: false,
      duration: 600,
    })
  ).start();
  const dot1 = animation.interpolate({
    inputRange: [0, 33, 66, 100],
    outputRange: [start, middle, end, middle],
  });
  const dot2 = animation.interpolate({
    inputRange: [0, 33, 66, 100],
    outputRange: [middle, end, middle, start],
  });
  const dot3 = animation.interpolate({
    inputRange: [0, 33, 66, 100],
    outputRange: [end, middle, start, middle],
  });
  return (
    <View style={styles.container}>
      <Animated.View
        style={[styles.dot, { backgroundColor: dot1 }]}
      ></Animated.View>
      <Animated.View
        style={[styles.dot, { backgroundColor: dot2 }]}
      ></Animated.View>
      <Animated.View
        style={[styles.dot, { backgroundColor: dot3 }]}
      ></Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 3,
  },
});
